import { IPaymentMethod, ISetupIntentSession } from '../../resource/payment-method/payment-method.types';

import * as types from './subscription.types';
import * as constants from './subscription.constants';

export const initialSubscriptionPage = (): types.IInitialSubscriptionPage => ({
  type: constants.INITIAL_SUBSCRIPTION_PAGE,
});

export const createSetupIntent = (): types.ICreateSetupIntent => ({
  type: constants.CREATE_SETUP_INTENT,
});

export const storeSetupSession = (session: ISetupIntentSession): types.IStoreSetupSession => ({
  type: constants.STORE_SETUP_SESSION,
  payload: session,
});

export const clearSetupSession = (): types.IClearSetupSession => ({
  type: constants.CLEAR_SETUP_SESSION,
});

export const addPaymentMethod = (payload: types.IAddPaymentMethodPayload): types.IAddPaymentMethod => ({
  type: constants.ADD_PAYMENT_METHOD,
  payload,
});

export const setDefaultPaymentMethod = (paymentMethodId: IPaymentMethod['id']): types.ISetDefaultPaymentMethod => ({
  type: constants.SET_DEFAULT_PAYMENT_METHOD,
  payload: paymentMethodId,
});

export const deletePaymentMethod = (paymentMethodId: IPaymentMethod['id']): types.IDeletePaymentMethod => ({
  type: constants.DELETE_PAYMENT_METHOD,
  payload: paymentMethodId,
});

export const startBilling = (): types.IStartBilling => ({
  type: constants.START_BILLING,
});

export const cancelSubscription = (): types.ICancelSubscription => ({
  type: constants.CANCEL_SUBSCRIPTION,
});

export const reactivateSubscription = (): types.IReactivateSubscription => ({
  type: constants.REACTIVATE_SUBSCRIPTION,
});

export const storeBillingInfo = (billingInfo: types.IBillingInfo): types.IStoreBillingInfo => ({
  type: constants.STORE_BILLING_INFO,
  payload: billingInfo,
});

export const clearBillingInfo = (): types.IClearBillingInfo => ({
  type: constants.CLEAR_BILLING_INFO,
});

export const saveBillingInfo = (
  payload: types.IBillingInfoInput,
  resolve?: (saved: boolean) => void,
): types.ISaveBillingInfo => ({
  type: constants.SAVE_BILLING_INFO,
  payload,
  resolve,
});
